import { useState } from 'react';
import MainLayout from "../layout/mainLayout";
import DownloadLog from '../components/DownloadLog';
import SalesDashboard from '../components/SalesDashboard';

export default function Report() {

    const [showReport, setShowReport] = useState('sales');

    return (
        <>
            <MainLayout
                removePadding={true}
                pageContent={
                    <div className='flex flex-col justify-between px-6' >

                        {/* Navigation */}

                        <div className='flex justify-center gap-4 py-4'>
                            <button onClick={() => setShowReport('sales')} className={`text-xl ${showReport === 'sales' ? 'font-bold' : ''}`}>
                                Sales Dashboard
                            </button>
                            <button onClick={() => setShowReport('download')} className={`text-xl ${showReport === 'download' ? 'font-bold' : ''}`}>
                                Download Log
                            </button>
                        </div>


                        {showReport === 'sales' ? <SalesDashboard /> : <DownloadLog />}
                    </div>
                }
            />
        </>
    );
}